import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
} from '@angular/core';
import { TableFormService } from '@brunsker/libs/core/ui/table/src';
import { SearchProductDataDisplayColumns } from '@brunsker/libs/portal-do-vendedor/utils/portal-vendedor-api';

@Component({
  selector: 'bs-add',
  templateUrl: './add.component.html',
  styleUrls: ['./add.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddComponent implements OnInit {
  @HostListener('click', ['$event']) onClick(event: Event) {
    event.stopPropagation();
    event.stopImmediatePropagation();
    this.eventAction.emit(this.data);
  }
  @Input() data!: SearchProductDataDisplayColumns;
  @Input() eventAction!: EventEmitter<SearchProductDataDisplayColumns>;
  constructor(
    private readonly tableFormService: TableFormService<SearchProductDataDisplayColumns>
  ) {}

  ngOnInit(): void {
    this.tableFormService.formGroups['search-product'].valueChanges.subscribe(
      (value) => {
        Object.keys(value).forEach((key) => {
          const currentDataProduct = this.data.produto;

          const formCurrentProduct = value[key]['produto'];

          if (currentDataProduct === formCurrentProduct) {
            this.data.quantidade = value[key]['quantidade'];
          }
        });
      }
    );
  }
}
